import { render, staticRenderFns } from "./CmFooter.vue?vue&type=template&id=788e441b"
import script from "./CmFooter.vue?vue&type=script&lang=js"
export * from "./CmFooter.vue?vue&type=script&lang=js"
import style0 from "./CmFooter.vue?vue&type=style&index=0&id=788e441b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports